export const APP_END_POINT = process.env.REACT_APP_END_POINT || '';
export const APP_ASSET_END_POINT = process.env.REACT_APP_ASSET_END_POINT || '';
export const APP_CP_ID = process.env.REACT_APP_CP_ID || '';
export const APP_RITTAI_PATH = process.env.REACT_APP_RITTAI_PATH || '';
export const APP_WOODONE_SIM_PATH = process.env.REACT_APP_WOODONE_SIM_PATH || '';
